var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('centered-auto-swiper'),_c('car-service',{attrs:{"id":"service"}}),_c('choose-us',{attrs:{"id":"choose"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }